import { useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { toast } from "sonner";
import axios from "axios";
import { API } from "../App";
import { ArrowRight, Loader2 } from "lucide-react";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    setLoading(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email: email.trim() });
      toast.success("Successfully subscribed to the newsletter!");
      setEmail("");
    } catch (error) {
      if (error.response?.data?.message === "Already subscribed") {
        toast.info("You're already subscribed!");
      } else {
        toast.error("Failed to subscribe. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-24 md:py-32 border-t border-border" data-testid="newsletter-section">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="font-mono text-xs uppercase tracking-widest text-primary">Newsletter</span>
            <h2 className="font-heading font-black text-4xl md:text-6xl uppercase tracking-tighter mt-2">
              Stay In The Loop
            </h2>
            <p className="text-muted-foreground mt-4 max-w-md">
              Get the latest articles, interviews, and underground music news delivered straight to your inbox. No spam, just raw content.
            </p>
          </div>
          <div>
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4">
              <Input
                type="email"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 bg-transparent border-b border-border focus:border-primary rounded-none px-0 h-14 font-mono text-sm"
                data-testid="newsletter-email-input"
                required
              />
              <Button 
                type="submit" 
                disabled={loading}
                className="bg-primary text-primary-foreground hover:bg-primary/90 h-14 px-8 font-mono uppercase tracking-widest text-xs btn-track"
                data-testid="newsletter-submit"
              >
                {loading ? (
                  <Loader2 className="h-4 w-4 animate-spin" />
                ) : (
                  <>
                    Subscribe
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </>
                )}
              </Button>
            </form>
            <p className="font-mono text-xs text-muted-foreground mt-4 uppercase tracking-wider">
              Unsubscribe anytime. We respect your inbox.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
